<template>
    <div>
        <button 
            class="c-top-nav__menu-trigger" 
            v-b-modal="navId" 
            @click="hideNav">
            <span class="c-top-nav__hamburger">
                <span class="sr-only">Menu</span>
            </span>
        </button>
            
        <aha-modal 
            :id="navId" 
            :title="modalTitle" 
            class="c-mobile-nav" 
            :ref="navRef" 
            :modalRole="modalRole"
            :modalContentRole="modalContentRole"
            :modalTag="modalTag"
            :showOnDesktop="showOnDesktop"
            hide-backdrop 
            hide-header 
            hide-footer 
            @shown="onShown" 
            @hidden="onHidden">
            <slot></slot>
        </aha-modal>
    </div>
</template>

<script>
    export default {
        // These props are optional.  By default, this component is designed for use in the main site navigation (header), which is what the default values here create.  If you need this component elsewhere, profile for instnace, you NEED to supply data for each of these props; they can be anything, as long as they are unique (except for the modalRole prop, which should be a valid role attribute value).
        // Example (profile version): 
        // <aha-mobile-nav nav-id="profile-navigation" nav-ref="profileNav" modal-title="Profile Navigation">
        props: {
            navId: {
                type: String,
                required: false,
                default: 'mobile-navigation'
            },
            navRef: {
                type: String,
                required: false,
                default: 'mobileNav'
            },
            modalTitle: {
                type: String,
                required: false,
                default: 'Mobile Navigation'
            },
            modalRole: {
                type: String,
                required: false,
                default: null
            },
            modalContentRole: {
                type: String,
                required: false,
                default: null
            },
            modalTag: {
                type: String,
                required: false,
                default: 'div' 
            },
            showOnDesktop: {
                type: Boolean,
                required: false,
                default: false 
            }
        },
        methods: {
            hideNav(evt) {
                if(this.$refs[this.navRef].is_show) {
                    evt.stopPropagation();
                    evt.stopImmediatePropagation();

                    document.body.classList.remove('modal-open--mobile-nav');

                    this.$refs[this.navRef].hide();
                }
            },
            onShown(evt) {
                const element = document.querySelector('.js-mobile-nav-positioning');
                const position = element.getBoundingClientRect();

                document.body.classList.add('modal-open--mobile-nav');

                evt.target.style.top = position.top + position.height + 'px';
                evt.target.style.bottom = 0;
            },
            onHidden(evt) {
                document.body.classList.remove('modal-open--mobile-nav');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/aha-mobile-nav.vue